import liff from '@line/liff';

const useLiff = () => {
    const initLiff = () => {




        return new Promise((resolve) => {
            liff.init({
                liffId: process.env.REACT_APP_LIFF_ID, // Use own liffId
            }).then(() => {
                resolve(liff)
            }).catch((err) => {
                resolve(null)
                alert(err)
                console.log(err)
            })
        })
    }

    return {
        initLiff
    }
}

export default useLiff